var _rect, _g, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEthLight = function SvgEthLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eth_light_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.998 5.334-.143.486v14.106l.143.142 6.547-3.87-6.547-10.864Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.997 5.334 9.45 16.198l6.548 3.87V5.334Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.997 21.308-.081.099v5.024l.08.236 6.552-9.227-6.551 3.868Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.997 26.667v-5.359L9.45 17.44l6.548 9.227Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.996 20.068 6.548-3.87-6.548-2.976v6.846Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.45 16.198 6.547 3.87v-6.846L9.45 16.198Z",
    fill: "#393939"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#EEEEEF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eth_light_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(5.333 5.333)",
    d: "M0 0h21.333v21.333H0z"
  })))));
};
export default SvgEthLight;